/** One combat step: the integer-tick clock every v4 replay and client run shares. */
export const COMBAT_TICK_MS = 1000 / 60;
/** 60 simulated minutes at 60 ticks per second. */
export const CAMPAIGN_V2_MAX_STAGE_TICKS = 60 * 60 * 60;
/** Multiplies rather than sums, so the result carries one rounding error instead of one per tick. */
export function tickToMs(tick) {
    return (tick * 1000) / 60;
}
export function msToTicksCeil(ms) {
    return Math.ceil((ms * 60) / 1000);
}
